export function isRedundant(value: any): boolean {
  return value === undefined || value === null || value === '';
}
